const normalizeLocale = (locale) => String(locale || '').trim();

const pickTranslation = (translations, locale) => {
  if (!translations || typeof translations !== 'object' || !locale) return null;
  const normalized = normalizeLocale(locale);
  if (!normalized) return null;
  if (translations[normalized]) return translations[normalized];
  const base = normalized.split('-')[0];
  if (base && translations[base]) return translations[base];
  return null;
};

export const getLocalizedShopItem = (item, locale) => {
  if (!item || typeof item !== 'object') return item;
  const trans = pickTranslation(item.translations, locale);
  if (!trans || typeof trans !== 'object') return item;

  const merged = { ...item };
  ['title', 'description', 'tags', 'externalLinkText'].forEach((field) => {
    if (trans[field] !== undefined) merged[field] = trans[field];
  });

  if (trans.seo && typeof trans.seo === 'object') {
    merged.seo = { ...(item.seo || {}), ...trans.seo };
  }

  return merged;
};

